import { render } from "./JobAdsMain.vue?vue&type=template&id=fc2a06e2&scoped=true"
import script from "./JobAdsMain.vue?vue&type=script&lang=js"
export * from "./JobAdsMain.vue?vue&type=script&lang=js"

import "./JobAdsMain.vue?vue&type=style&index=0&id=fc2a06e2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc2a06e2"]])

export default __exports__